import { Component, computed, input } from '@angular/core';

import { CmsTeaser } from '@fcom/core-api';

import { toLinkData } from '../../services/template/data-mappers';

@Component({
  selector: 'cms-cta-with-image-and-text',
  template: `
    <fin-cta-with-image-and-text
      [target]="cmsTarget()"
      [teaserTitle]="content().teaserTitle"
      [teaserText]="content().teaserText"
      [iconUrl]="content().iconUrl"
    />
  `,
  standalone: false,
})
export class CmsCtaWithImageAndTextComponent {
  content = input.required<CmsTeaser>();

  cmsTarget = computed(() => {
    return toLinkData(this.content().target);
  });
}
